import * as Yup from 'yup';

export default Yup.object().shape({
  wordToType: Yup.string().required("Field can't be blank"),
});
